module.exports = __webpack_public_path__ + "static/media/home-style-3.addf5bb8.svg";